<template>
  <aside
    class="app-sidebarr"
    :class="computedClass"
    :style="computedStyle"
  >
    <ul class="app-sidebarr__menu">
      <template v-for="(item, key) in clients">
        <app-sidebar-link
          :key="key"
          :minimized="minimized"
          :title="item.spotIdentifier + ' - ' + carPlate(item.plate) + ' - ' + item.period"
        />
      </template>
    </ul>
  </aside>
</template>

<script>
import { navigationRoutes } from './NavigationRoutes'
import AppSidebarLink from './components/AppSidebarLink'
import { ColorThemeMixin } from '../../../services/vuestic-ui'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  name: 'app-sidebar-right',
  inject: ['contextConfig'],
  components: {
    AppSidebarLink,
  },
  mixins: [ColorThemeMixin, errorHandlerMixin],
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      default: 'secondary',
    },
  },
  data () {
    return {
      items: navigationRoutes.routes,
      notificationErrors: null,
      intervalId: null,
      clients: null,
    }
  },
  computed: {
    computedClass () {
      return {
        'app-sidebarr--minimizedd': this.minimized,
      }
    },
    computedStyle () {
      return {
        backgroundColor: this.contextConfig.invertedColor ? 'white' : this.colorComputed,
      }
    },
  },
  watch: {
  },
  methods: {
    carPlate (plate) {
      return plate !== null && plate.length > 0 ? plate : this.$t('sidebar.noPlate')
    },
    hasActiveByDefault (item) {
      return item.children.some(child => child.name === this.$route.name)
    },
  },
  mounted () {
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
}

</script>

<style lang="scss">
.app-sidebarr {
  overflow: auto;
  display: flex;
  max-height: 100%;
  flex: 0 0 16rem;

  @include media-breakpoint-down(sm) {
    flex: 0 0 100%;
  }

  &--minimizedd {
    flex: 0 0 0;
  }

  &__menu {
    margin-bottom: 0;
    padding-top: 2.5625rem;
    padding-bottom: 2.5rem;
    list-style: none;
    padding-left: 0;
    width: 100%;
  }
}
</style>
